<template>
  <div id="app">
    <!-- <router-view/> -->
    <indexPage></indexPage>
  </div>
</template>

<script>
import indexPage from './pages/index';
export default {
  name: 'App',
  components: {
    indexPage
  },
  mounted () {
    const script = document.createElement('script');
    script.src = 'https://s95.cnzz.com/z_stat.php?id=1277801347&web_id=1277801347';
    script.language = 'JavaScript';
    document.body.appendChild(script);
  },
  watch: {
    '$route' () {
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = '/';
        window._czc.push(['_trackPageview', contentUrl, refererUrl]);
      }
    }
  }
};
</script>

<style>
#app {
  font-family: "Helvetica Neue",Helvetica,Arial,"pingfang sc","Hiragino Sans GB","Microsoft YaHei","微软雅黑",STHeiti,SimSun,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #2168D2;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue